<template>
    <div class="app-container">
    <el-dialog title="添加用户" :visible.sync="dialogVisible" width="30%">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="formparams.userName" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="角色">
               <el-select v-model="formparams.role" placeholder="请选择">
                <el-option
                  v-for="item in this.userRole"
                  :key="item.role"
                  :label="item.remark"
                  :value="item.role"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属数据源">
               <el-select v-model="formparams.clubMemberCode" placeholder="请选择">
                <el-option
                  v-for="item in this.clubMemberCodeS"
                  :key="item.clubmembercode"
                  :label="item.clubname"
                  :value="item.clubmembercode"
                ></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="role" label="用户名"></el-table-column>
        <el-table-column prop="remark" label="角色"> </el-table-column>
        <!-- <el-table-column prop="clubName" label="所属数据源"></el-table-column> -->
        <el-table-column width="300" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row.id)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getRole, registUser, userGetrole, getClubMemberCodes } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      query:{
        userName:''
      },
      //角色标识
      userRole:[
      ],
      //数据源标识
      clubMemberCodeS:[],
      formparams:{
        userName:'',
        role:'',
        clubMemberCode:''
      },
      //表单校验
      rules:{
        userName:[
          { required: true, message: '请输入用户名账户', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ]
      },
      //用户列表
      tableData:[
      ],
      total: 0,
      currentPage: 1,
      params: {
        page: 1,
        size: 20
      }
    }
  },
  components: {
    mainHead
  },
  mounted() {
    this.getUser()
  },
  methods: {
    showDialog(){
      this.dialogVisible =true
      this.userGetrole()
      this.getClubMemberCodes()
    },
    //获取用户角色权限列表
    userGetrole(){
      userGetrole().then((res)=>{
        if(res.msg=='success'){
          this.userRole = res.data  
        } else {
          this.$message.error(res.data)
        }
      })
    },
    getUser(){
      getRole().then((res)=>{
        if(res.msg=='success'){
          this.tableData = res.data  
        } else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    //获取数据源列表
    getClubMemberCodes(){
      getClubMemberCodes().then((res)=>{
        if(res.msg=='success'){
          this.clubMemberCodeS = res.data  
        } else {
          this.$message.error(res.data)
        }

      })
    },
    //提交增加数据源接口
    // addDataSource
    submitForm(formparams) {
      this.$refs[formparams].validate((valid) => {
        if (valid) {
          registUser(this.formparams).then((res)=>{
            if (res.msg == 'success') {
              this.dialogVisible = false;
              this.$message({
                message:'添加成功',
                type: "success"
              });
              this.getUser();
            } else {
              this.$message.error('失败');
            }
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    edit(id){
      this.$message.error('暂不可编辑')
    },
    removeList(id){
      this.$message.error('暂未开发')
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// roleModule.vue?2b9e9ff4